import icon from 'assets/icons/chart.svg';
import React, {Component, PureComponent} from 'react';
import {ResponsiveContainer, Tooltip, Treemap} from 'recharts';
import './ToiStructureBranch.style.scss';

export default class ToiStructureBranch extends Component {
  render() {
    const data = [
      {name: 'HA NOI', value: 15},
      {name: 'HO CHI MINH', value: 18},
      {name: 'BAC NINH', value: 6},
      {name: 'THAI NGUYEN', value: 2},
      {name: 'HAI PHONG', value: 10},
      {name: 'BINH DUONG', value: 5},
      {name: 'DONG NAI', value: 3},
      {name: 'HA NAM', value: 4},
      {name: 'DA NANG', value: 8},
      {name: 'BIEN HOA', value: 2},
      {name: 'SAI GON', value: 10},
      {name: 'VINH PHUC', value: 5},
      {name: 'HOAN KIEM', value: 7},
      {name: 'PHU MY HUNG', value: 5},
    ];
    const COLORS = [
      '#A07E20',
      '#FBC83A',
      '#DADADA',
      '#FEFEA2',
      '#B3B3B3',
      '#C4B43D',
      '#887D2A',
      '#AAAAAA',
      '#DADADA',
      '#7C7C7C',
      '#B6AC72',
      '#CBCB36',
      '#FDDF3E',
      '#898989',
    ];
    return (
      <div className='ToiStructureBranchcontainer'>
        <h1 className='ToiStructureBranchtitle'>
          <img src={icon} alt='' style={{marginRight: 8}} />
          TOI STRUCTURE by BRANCH
        </h1>
        <ResponsiveContainer width='100%' height={230}>
          <Treemap data={data} dataKey='value' content={<CustomizedContent colors={COLORS} />}>
            <Tooltip cursor={false} content={<CustomTooltip data={data} colors={COLORS} />} />
          </Treemap>
        </ResponsiveContainer>
      </div>
    );
  }
}
class CustomizedContent extends PureComponent {
  render() {
    const {root, x, y, width, height, index, colors, name} = this.props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: colors[index % root.children.length],
            stroke: '#fff',
            strokeWidth: 1,
          }}
          rx={4}
        />

        <text
          x={x + 8}
          y={y + height / 2 + 7}
          textAnchor='start'
          fill='#000000'
          fontSize={14}
          fontWeight={600}>
          {name}
        </text>
      </g>
    );
  }
}

const CustomTooltip = (props) => {
  const {active, payload, data, colors} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;
    const index = data.findIndex((el) => el.key === item.key);

    return (
      <div className='custom-tooltip' style={{backgroundColor: colors[index % data.length]}}>
        <span className='name'>{item.name}</span>
        <span className='desc'>{item.value}%</span>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewByBranch/components/ToiStructureBranch/ToiStructureBranch.js